import { apiFetch } from '../httpClient';

const SCHEDULE_TEMPLATE_LIST_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_SCHEDULE_TEMPLATE_LIST_ENDPOINT_TEMPLATE ||
  '/api/teams/:teamId/schedule-templates';
const SCHEDULE_TEMPLATE_DETAIL_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_SCHEDULE_TEMPLATE_DETAIL_ENDPOINT_TEMPLATE ||
  '/api/teams/:teamId/schedule-templates/:templateId';

function buildPathFromTemplate(template, pathParams = {}) {
  return Object.entries(pathParams).reduce((path, [key, value]) => {
    return path
      .replace(`:${key}`, encodeURIComponent(String(value)))
      .replace(`{${key}}`, encodeURIComponent(String(value)));
  }, template);
}

function buildTemplateListPath(teamId) {
  return buildPathFromTemplate(SCHEDULE_TEMPLATE_LIST_ENDPOINT_TEMPLATE, { teamId });
}

function buildTemplateDetailPath(teamId, templateId) {
  return buildPathFromTemplate(SCHEDULE_TEMPLATE_DETAIL_ENDPOINT_TEMPLATE, { teamId, templateId });
}

export async function fetchScheduleTemplates({ teamId }) {
  return apiFetch(buildTemplateListPath(teamId), {
    method: 'GET',
  });
}

export async function createScheduleTemplate({ teamId, payload }) {
  return apiFetch(buildTemplateListPath(teamId), {
    method: 'POST',
    body: payload,
  });
}

export async function updateScheduleTemplate({ teamId, templateId, payload }) {
  return apiFetch(buildTemplateDetailPath(teamId, templateId), {
    method: 'PATCH',
    body: payload,
  });
}

export async function deleteScheduleTemplate({ teamId, templateId }) {
  return apiFetch(buildTemplateDetailPath(teamId, templateId), {
    method: 'DELETE',
  });
}

